import { S_AUTH_TOKEN, webStorage } from "../utils/webStorage";
import { getBankCardOptions } from "../services/userService";
import { useState } from "react";

const useFetchBankCards = ({ onFetchEmpty }) => {
  const [bankCardsLoaded, setBankCardsLoaded] = useState(false);
  const [bankCards, setBankCards] = useState([]);
  const [selectedBankCard, setSelectedBankCard] = useState(null);
  const [showCardForm, setShowCardForm] = useState(true);
  const getBankCards = async () => {
    const token = webStorage.get(S_AUTH_TOKEN);
    if (token) {
      const cards = await getBankCardOptions();
      if (cards.length > 0) {
        setShowCardForm(false);
        setBankCards(cards);
        let _card = cards.find(x => x.data.defaultFlag == "1");
        if (!_card) {
          _card = cards[0];
        }
        setSelectedBankCard(_card);
      } else {
        setBankCards([]);
        setShowCardForm(true);
        onFetchEmpty && onFetchEmpty();
      }
      setBankCardsLoaded(true);
    } else {
      setShowCardForm(true);
      onFetchEmpty && onFetchEmpty();
    }
  };
  return {
    bankCards,
    bankCardsLoaded,
    selectedBankCard,
    setSelectedBankCard,
    showCardForm,
    setShowCardForm,
    getBankCards
  };
};
export default useFetchBankCards;
